import * as React from "react";
import { TPublicationReportReportPresentationModel } from "../../../../presenter/report/model/PublicationsReportReportPresentationModel";
import ReactPDF, { View, Text } from "@react-pdf/renderer";

const PublicationsReportPDFReportsGrid = ({
  translate,
  reports,
  styles
}: {
  translate: any;
  reports: TPublicationReportReportPresentationModel[];
  styles: ReactPDF.Styles;
}) => {
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <View style={styles.tableCol}>
          <Text style={{ ...styles.tableCell, textAlign: "right" }}>
            {translate("publications_report.reports.version")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("publications_report.reports.submit_date")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("publications_report.reports.formal_evaluation_status")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("publications_report.reports.formal_evaluation_date")}
          </Text>
        </View>
      </View>
      {reports.map((item, index) => (
        <View key={index}>
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCol}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {item.version}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.submitDate}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {item.formalEvaluationStatus}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.formalEvaluationDate}</Text>
            </View>
          </View>
        </View>
      ))}
    </View>
  );
};

export default PublicationsReportPDFReportsGrid;
